<template>
<file-layout :show-header="isPublic" :file-name="fileName" :allow-share="false">
    <div v-if="isPcMode" class="pc-folder-view">
      <div class="viewbox">
        <div class="nav">
          <div class="left">
            <div class="nav-item" v-for="item of paths" :key="item.fileId">
              <a href="javascript:void(0)" @click="openItem(item)">
                {{ item.fileName }}
              </a>
              <svg-icon icon-class="arrow-forward"></svg-icon>
            </div>
          </div>
          <div class="right">
            <div class="loading">
              <img v-if="isLoading" class="img" src="@/assets/h5/loading2.gif">
              <UploadPopper :fid="this.fileId" :isRead="isRead" :toolTip="uploadToolTip" @handleUpload="handleUpload"></UploadPopper>
              <CreatePopper @handleFolderDialog="handleFolderDialog" :isRead="isRead" :isHeader="false" @handleCreate="handleCreate"></CreatePopper>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list-header">
            <div class="prefix"></div>
            <div class="type">
              <span>{{$t("类型#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1")}}</span>
            </div>
            <div class="name">
              <span>{{$t("文件名称#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1")}}</span>
            </div>
            <div class="size">
              <div class="separator"></div>
              <span>{{$t("最近更新#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1")}}</span>
            </div>
            <div class="size">
              <div class="separator"></div>
              <span>{{$t("大小#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1")}}</span>
            </div>
            <div class="action">
              <span></span>
            </div>
          </div>
          <div class="list-body">
            <div v-if="isEmpty" class="empty">
              <div class="message">
                <img src="@/assets/h5/notfound.png">
                <div>
                  <span>{{$t("该文件夹内无文件#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1")}}</span>
                </div>
              </div>
            </div>
            <div class="result" v-infinite-scroll="load" infinite-scroll-distance="60" :infinite-scroll-disabled="disabled" :infinite-scroll-immediate="immediate">
              <div class="row" v-for="item of source" :key="item.fileId">
                <div class="prefix"></div>
                <div class="type">
                  <div>
                    <div class="icon-container" v-show="showSvgIcon(item)">
                      <svg-icon :icon-class="getFileIcon(item)"></svg-icon>
                      <pcShortCut v-if="item.shortcut === true" :class="[
                          'icon-shortcut',
                          item.type === '1' ? 'icon-shortcut-dir' : '',
                        ]"></pcShortCut>
                    </div>
                    <div v-if="isPicture(item.fileName)" v-show="!showSvgIcon(item)" class="img-box">
                      <img @error="onImageError(item)" @load="onImageLoad(item)" :src="imgSrc(item.fileId)">
                    </div>
                  </div>
                </div>
                <div class="name">
                  <a href="javascript:void(0)" @click="openItem(item)">
                    {{ item.fileName }}
                  </a>
                  <svg-icon v-if="isTemplate(item)" :class="[
                      'template_icon',
                      cloudI18n === 'en-us' ? 'template_icon_en' : '',
                    ]" :icon-class="
                      cloudI18n === 'en-us'
                        ? 'template_mark_en'
                        : 'template_mark'
                    "></svg-icon>
                </div>
                <div class="size">
                  <span>{{ formatTime(item) }}</span>
                </div>
                <div class="size">
                  <span>{{ formatFileSize(item) }}</span>
                </div>
                <div class="action">
                  <moo-dropdown v-show="menuFilter(item).length > 0" trigger="click" @command="handleMenu">
                    <div class="action-tab">
                      <svg-icon icon-class="file-more"></svg-icon>
                    </div>
                    <moo-dropdown-menu slot="dropdown">
                      <moo-dropdown-item :command="{ ...data, ...item }" v-for="data in menuFilter(item)">
                        {{ data.name }}
                      </moo-dropdown-item>
                    </moo-dropdown-menu>
                  </moo-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="h5-folder-view">
      <div class="list-body">
        <div v-if="isEmpty" class="empty">
          <div class="message">
            <img src="@/assets/h5/notfound.png">
            <div>
              <span>{{$t("该文件夹内无文件#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_2")}}</span>
            </div>
          </div>
        </div>
        <div class="result" v-infinite-scroll="load" infinite-scroll-distance="60" :infinite-scroll-disabled="disabled" :infinite-scroll-immediate="immediate">
          <div class="row" v-for="item of source" :key="item.fileId" @click="openItem(item)">
            <div class="prefix"></div>
            <div class="type">
              <div>
                <div class="icon-container" v-show="showSvgIcon(item)">
                  <svg-icon :icon-class="getFileIcon(item)"></svg-icon>
                  <mobileShortCut v-if="item.shortcut === true" :class="[
                      'icon-shortcut',
                      item.type === '1' ? 'icon-shortcut-dir' : '',
                    ]"></mobileShortCut>
                </div>
              </div>
              <div v-if="isPicture(item.fileName)" v-show="!showSvgIcon(item)" class="img-box">
                <img @error="onImageError(item)" @load="onImageLoad(item)" :src="imgSrc(item.fileId)">
              </div>
            </div>
            <div class="name">
              <div :class="[
                  'filename-container',
                  isTemplate(item) ? '' : 'filename-container-noTemplate',
                ]">
                <span class="caption">
                  {{ item.fileName }}
                </span>
                <svg-icon v-if="isTemplate(item)" :class="[
                    'template_icon',
                    cloudI18n === 'en-us' ? 'template_icon_en' : '',
                  ]" :icon-class="
                    cloudI18n === 'en-us' ? 'template_mark_en' : 'template_mark'
                  "></svg-icon>
              </div>
              <div>
                <span class="size">{{ formatFileSize(item) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MkdirDialog @openItem="openItem" @refresh="refresh" :fileId="fileId" ref="mkdir" :folderPath="folderPath"></MkdirDialog>
    <RenameDialog :metadata="metadata" :fileName="fileName" :fileId="fileId" ref="rename" :folderPath="folderPath" @refresh="refresh"></RenameDialog>
    <DeleteDialog :fileName="fileName" :fileId="fileId" ref="delete" :folderPath="folderPath" @refresh="refresh"></DeleteDialog>
    <PreCheckFolderUploadDialog @handlUpload="handlePreCheckUpload" ref="preCheck"></PreCheckFolderUploadDialog>
  </file-layout>
</template>

<script>
import { intl } from 'tci18n-vue2'
import cookies from "js-cookie";
import { mapState, mapActions } from "vuex";
import { getFiles, getUserAuthList, checkFile } from "@/api/h5/file";
import FileLayout from "@/components/h5/Layout";
import CreatePopper from "./popper/CreatePopper.vue";
import UploadPopper from "./popper/UploadPopper.vue";
import moment from "moment";
import MkdirDialog from "./dialog/mkdirDialog";
import RenameDialog from "./dialog/renameDialog";
import DeleteDialog from "./dialog/deleteDialog.vue";
import { fileImgName } from "@/utils/avatar";
import mobileShortCut from "../assets/mobileShortCut.vue";
import pcShortCut from "../assets/pcShortCut.vue";
import PreCheckFolderUploadDialog from "@/pages/CloudHome/components/PreCheckFolderUploadDialog.vue";

export default {
  components: {
    FileLayout,
    CreatePopper,
    UploadPopper,
    MkdirDialog,
    RenameDialog,
    DeleteDialog,
    mobileShortCut,
    pcShortCut,
    PreCheckFolderUploadDialog
  },
  props: {
    rootId: {
      type: String
    },
    fileId: {
      type: String
    },
    spaceId: {
      type: String
    },
    auth: {
      type: String
    },
    metadata: {
      type: Object
    },
    isPublic: {
      type: Boolean
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    sameSpace: {
      type: Boolean,
      default: false
    },
    productType: {
      type: String,
      default: ""
    },
    userInfo: {
      type: Object,
      default: null
    }
  },
  watch: {
    source(val) {
      this.$emit("updateSource", val);
    }
  },
  data() {
    return {
      source: [],
      paths: [],
      iconStatus: [],
      folderVisible: true,
      pager: null,
      isEmpty: false,
      disabled: true,
      immediate: false,
      fileSpaceId: "",
      menuOptions: [
      { name: intl.$t("打开#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"), operation: "open" },
      { name: intl.$t("下载#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"), operation: "download" },
      { name: intl.$t("下载为PDF#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"), operation: "downloadPDF" },
      { name: intl.$t("重命名#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"), operation: "rename" },
      { name: intl.$t("删除#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"), operation: "delete" }],

      clickType: ""
    };
  },
  methods: {
    ...mapActions(["setFileAuth"]),
    isTemplate(item) {
      return item.templateType && item.templateType !== 0;
    },
    handleFolderDialog(value) {
      this.$refs.mkdir.handleFolderDialog(value);
    },
    handleRenameDialog(value, item) {
      this.$refs.rename.handleRenameDialog(value, item);
    },
    handleDeleteDialog(value, item) {
      this.$refs.delete.handleDeleteDialog(value, item);
    },
    handleMenu(item) {
      switch (item.operation) {
        case "open":
          return this.openItem(item);
        case "download":
          this.downLoadItem(item);
          return;
        case "downloadPDF":
          this.downLoadItemPDF(item);
          return;
        case "rename":
          this.handleRenameDialog(true, item);
          return;
        case "delete":
          this.handleDeleteDialog(true, item);
          return;
        default:
          break;
      }
    },
    handleCreate(value) {
      this.$emit("handleCreate", value, this.fileId);
    },
    handlePreCheckUpload() {
      this.$emit("handleUpload", this.clickType);
    },
    handleUpload(value) {
      this.clickType = value;
      if (this.clickType === 'file') {
        this.$emit("handleUpload", this.clickType);
      } else {
        // 文件夹多了提前弹窗
        this.$refs.preCheck.handleCheckDialog(true);
      }
    },
    refresh() {
      this.resetPager();
      this.load();
    },
    resetPager() {
      this.source = [];
      this.isEmpty = false;
      this.disabled = false;
      this.pager = {
        total: 0,
        since: 0,
        size: 100
      };
    },
    downLoadItem(item) {
      if (item.type === "0") {
        this.$emit("download", item.fileId, false, item);
      } else {
        this.$emit("download", item.fileId, true, item);
      }
    },
    downLoadItemPDF(item) {
      this.$emit("downloadPDF", item);
    },
    openItem(item) {
      if (item.type === "0") {
        // this.$emit("download", item.fileId);
        // const { origin, pathname } = window.location;
        // var openUrl = origin + pathname + `?fid=${item?.fileId}`;
        // if (pathname == "/web/file") {
        //   openUrl = origin + pathname + `#/?fid=${item?.fileId}`;
        // }
        // window.open(openUrl);
        window.open(item.fileUrl);
      } else {
        this.$emit("open-item", item);
      }
    },

    fileOpen(item) {
      if (item.type === "0") {
        const { origin, pathname } = window.location;
        var openUrl = origin + pathname + `?fid=${item?.fileId}`;
        if (pathname == "/web/file") {
          openUrl = origin + pathname + `#/?fid=${item?.fileId}`;
        }
        window.open(openUrl);
      } else {
        this.$emit("open-item", item);
      }
    },

    load() {
      this.disabled = true;
      const key = `${this.rootId}-code`;
      const pass = cookies.get(key) || "";
      const { size } = this.pager;
      const nextSince = this.source.length;
      const options = {
        size: size,
        since: nextSince,
        password: pass,
        rootId: this.rootId,
        parentId: this.fileId
      };
      getFiles(options).then((e) => {
        this.disabled = false;
        const { code, data } = e;
        if (code !== 200) return;
        const { paths, result, pager } = data;
        this.isEmpty = pager.total === 0;
        this.pager = pager;
        this.paths = paths;
        this.source.push(...result);
      });
    },

    formatFileSize(item, decimals = 2) {
      if (item.type !== "0") return "-";
      const bytes = item.size;
      if (typeof bytes === "string") {
        bytes = parseInt(bytes);
      }
      if (bytes === 0) return "0 B";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["B", "K", "M", "G", "T", "P", "E", "Z", "Y"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },

    formatTime(item) {
      return moment(item?.operationTime).format(intl.$t("MM月DD日 HH:mm#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"));
    },

    isPicture(name) {
      name = name.trim();
      let index = name.lastIndexOf(".");
      if (index === -1 || index === name.length - 1) return false;
      const ext = name.substr(index + 1).toLowerCase();
      const pic =
      ext === "png" ||
      ext === "jpg" ||
      ext === "jpeg" ||
      ext === "gif" ||
      ext === "bmp" ||
      ext === "ico" ||
      ext === "heic" ||
      ext === "webp";
      return pic;
    },

    getFileIcon(item) {
      const { fileName, type, contentType = "" } = item;
      if (contentType == "DOCUMENT") {
        return "cloud-online-doc";
      }
      if (type !== "0") return "cloud-folder";
      const name = fileName.trim();
      const index = name.lastIndexOf(".");
      if (index === -1) return "cloud-other";
      const ext = name.
      substr(index).
      replace(".", "").
      toLowerCase();
      return fileImgName(ext);
    },

    onDownloand(item) {
      this.$emit("download", item.fileId);
    },

    imgSrc(fileId) {
      const key = `${this.rootId}-code`;
      const pass = cookies.get(key) || "";
      const url = `${process.env.VUE_APP_INNERNET_URL}/public/thumbnail/${fileId}?rootId=${this.rootId}&password=${pass}`;
      return url;
    },

    onImageError(e) {
      const item = this.iconStatus.find((t) => t.key === e.fileId);
      if (item) {
        item.value = -1;
        return;
      }
      this.iconStatus.push({
        key: e.fileId,
        value: -1
      });
    },

    onImageLoad(e) {
      const item = this.iconStatus.find((t) => t.key === e.fileId);
      if (item) {
        item.value = 1;
        return;
      }
      this.iconStatus.push({
        key: e.fileId,
        value: 1
      });
    },

    showSvgIcon(e) {
      const item = this.iconStatus.find((t) => t.key === e.fileId);
      if (item == null) return true;
      if (item.value !== 1) return true;
    },

    async checkFileAuth() {
      const rid = this.$route.query.rid;
      if (!!rid && rid !== this.fileId) {
        try {
          const { data = {}, code = "" } = await checkFile(this.fileId);
          const { auth } = data;
          this.setFileAuth(auth);
          this.fileSpaceId = data?.fileInfo?.spaceId || "";
          this.$emit("floderAuthChange", auth);
        } catch {}
      }
    },
    updateDocInfo(data) {
      // 修改最后一个路径名称
      if (this.paths.length > 0) {
        this.paths[this.paths.length - 1].fileName = data.fileName;
      }
    }
  },
  mounted() {
    this.checkFileAuth();
  },
  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode,
      fileAuth: (state) => state.fileAuth,
      cloudI18n: (state) => state.cloudI18n
    }),
    uploadToolTip() {
      return this.productType === "CLOUD_DOCUMENT" ? intl.$t("支持以下文件格式：.doc、.docx、.xls、.xlsx、.ppt、.pptx、.pdf。#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1") :

      "";
    },
    isRead() {
      let isDisabled = true;
      const rid = this.$route.query.rid;
      if (!!rid && rid !== this.fileId) {
        isDisabled =
        this.fileAuth == "READ" || this.fileAuth == "READ_DOWNLOAD";
        return isDisabled;
        // return isDisabled || this.spaceId != this.fileSpaceId;
      }
      isDisabled = this.auth == "READ" || this.auth == "READ_DOWNLOAD";
      return isDisabled;
      // return isDisabled || !this.sameSpace;
    },
    folderPath() {
      return this.paths.map((item) => item.fileName).join("/");
    },
    menuFilter(item) {
      return (item) => {
        let menuAuth = item.auth;
        let shortcut = item.shortcut;
        let options = ["open"];
        switch (menuAuth) {
          case "READ":
            return this.menuOptions.filter((item) =>
            options.includes(item.operation)
            );
          case "READ_DOWNLOAD":
            if (shortcut === false) {
              if (item.contentType === "DOCUMENT") {
                options.push("downloadPDF");
              } else {
                //数组后面追加
                options.push("download");
              }
            }
            return this.menuOptions.filter((item) =>
            options.includes(item.operation)
            );
          case "WRITE":
            // 删除delete选项
            if (shortcut === true) {
              return this.menuOptions.filter(
                (item) => item.operation !== "download" && item.operation !== "downloadPDF" && item.operation !== "delete"
              );
            } else {
              if (item.contentType === "DOCUMENT") {
                return this.menuOptions.filter((item) => item.operation !== "download" && item.operation !== "delete");
              } else {
                return this.menuOptions.filter((item) => item.operation !== "downloadPDF" && item.operation !== "delete");
              }
            }
          case "ALL":
            if (shortcut === true) {
              return this.menuOptions.filter((item) => item.operation !== "download" && item.operation !== "downloadPDF");
            }
            if (item.contentType === "DOCUMENT") {
              return this.menuOptions.filter((item) => item.operation !== "download");
            } else {
              return this.menuOptions.filter((item) => item.operation !== "downloadPDF");
            }
        }
      };
    },
    isLoading() {
      const total = this.pager.total;
      const loaded = this.source.length;
      const hasMore = loaded < total;
      return hasMore && this.disabled;
    },
    fileName() {
      return this.metadata ? this.metadata?.fileName : "";
    }
  },

  created() {
    this.resetPager();
  }
};
</script>

<style lang="scss" scoped>
.pc-folder-view {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background: #ebedef;

  .viewbox {
    display: flex;
    flex-direction: column;
    margin: 20px 5px;
    width: 100%;
    border-radius: 2px;
    max-width: 1400px;
    background: #fff;
    border: 0.5px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);

    .nav {
      display: flex;
      padding: 20px 20px 17px 20px;
      align-items: center;
      justify-content: space-between;

      .left {
        display: flex;

        .nav-item {
          display: flex;
          align-items: center;

          a {
            font-weight: 400;
            font-size: 13px;
            color: #5c70ff;
            text-decoration: none;

            &:active {
              color: #4959cc;
            }
          }

          svg {
            font-size: 13px;
            color: rgba(0, 0, 0, 0.7);
          }

          &:last-child {
            a {
              text-decoration: none;
              cursor: default;
              font-weight: 400;
              font-size: 13px;
              color: rgba(0, 0, 0, 0.7);

              &:hover {
                color: rgba(0, 0, 0, 0.7);
              }

              &:active {
                color: rgba(0, 0, 0, 0.7);
              }
            }

            svg {
              font-size: 13px;
              color: rgba(0, 0, 0, 0.7);
            }
          }
        }
      }

      .right {
        display: flex;

        @media (max-width: 600px) {
          .loading {
            display: none !important;
          }
        }

        .loading {
          display: flex;
          align-items: center;

          .img {
            width: 16px;
            margin-right: 6px;
          }
        }

        span {
          font-size: 13px;
          color: rgba(0, 0, 0, 0.7);
        }
      }
    }

    .list {
      flex-grow: 1;
      padding: 0px 20px;
      display: flex;
      flex-direction: column;

      .action-tab {
        font-size: 25px;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 !important;
        border-radius: 4px;
        cursor: pointer;

        svg {
          width: 17px;
          height: 17px;
        }

        &:hover {
          background: #f4f6f9;
        }
      }

      @media (max-width: 600px) {
        .list-header {
          padding-left: 10px;
          display: flex;
          height: 42px;
          align-items: center;
          background: #f7f7f8;
          box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;

          .separator {
            display: none;
          }

          .prefix {
            width: 1px;
          }

          .type {
            width: 60px;
          }

          .name {
            flex-grow: 1;
          }

          .size {
            width: 60px;
          }

          .action {
            width: 70px;
          }

          span {
            font-weight: 500;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);
            line-height: 18px;
          }
        }

        .list-body {
          display: flex;
          flex-grow: 1;
          position: relative;

          .empty {
            height: 50%;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .message {
              text-align: center;

              img {
                width: 120px;
              }

              span {
                font-size: 17px;
                color: rgba(0, 0, 0, 0.3);
              }
            }
          }

          .result {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            overflow: auto;
            flex-direction: column;

            .row {
              width: 100%;
              display: flex;
              align-items: center;

              .prefix {
                width: 1px;
                height: 60px;
                flex-shrink: 0;
              }

              .type {
                width: 60px;
                height: 60px;
                display: flex;
                align-items: center;
                flex-shrink: 0;

                svg {
                  font-size: 38px;
                }

                .icon-container {
                  position: relative;

                  .icon-shortcut-dir {
                    left: 0 !important;
                    bottom: 3px !important;
                  }
                  .icon-shortcut {
                    position: absolute;
                    width: 16px;
                    height: 16px;
                    left: 3px;
                    bottom: 0px;
                  }
                }

                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
              }

              .name {
                display: flex;
                align-items: center;
                //flex-grow: 1;
                height: 60px;
                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
                // width: calc(100% - 210px);
                min-width: 60px;

                a {
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  text-decoration: none;
                  color: #5c70ff;

                  &:active {
                    color: #4959cc;
                  }
                }

                .template_icon_en {
                  width: 52px !important;
                }
                .template_icon {
                  overflow: unset;
                  width: 28px;
                  height: 16px;
                  margin: 0px 4px;
                }
              }

              .size {
                display: flex;
                align-items: center;
                width: 70px;
                height: 60px;
                flex-shrink: 0;

                span {
                  padding-left: 8px;
                  font-weight: 400;
                  font-size: 14px;
                  color: rgba(0, 0, 0, 0.5);
                }

                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
              }

              .action {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 60px;
                height: 60px;
                flex-shrink: 0;

                span {
                  padding-left: 8px;

                  button {
                    width: 64px;
                    height: 30px;
                    background: #ffffff;
                    border: 0.5px solid rgba(0, 0, 0, 0.3);
                    border-radius: 4px;
                    cursor: pointer;

                    &:hover {
                      background: #eaeaea;
                      border: 0.5px solid rgba(0, 0, 0, 0.4);
                    }

                    &:active {
                      background: #e2e2e2;
                      border: 0.5px solid rgba(0, 0, 0, 0.5);
                    }
                  }
                }

                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
              }
            }
          }
        }
      }

      @media (min-width: 600px) {
        .list-header {
          display: flex;
          height: 42px;
          align-items: center;
          background: #f7f7f8;
          box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;

          .separator {
            margin-right: 8px;
            width: 1px;
            height: 18px;
            box-shadow: -0.5px 0 rgba(0, 0, 0, 0.1) inset;
          }

          .prefix {
            width: 20px;
          }

          .type {
            width: 60px;
          }

          .name {
            flex-grow: 1;
          }

          .size {
            display: flex;
            width: 160px;
            align-items: center;
          }

          .action {
            display: flex;
            width: 160px;
            align-items: center;
          }

          span {
            font-weight: 500;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);
            line-height: 18px;
          }
        }

        .list-body {
          display: flex;
          flex-grow: 1;
          min-height: 200px;
          position: relative;

          .empty {
            height: 100%;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .message {
              text-align: center;

              img {
                width: 120px;
              }

              span {
                font-size: 17px;
                color: rgba(0, 0, 0, 0.3);
              }
            }
          }

          .result {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            overflow: auto;
            flex-direction: column;

            .row {
              width: 100%;
              display: flex;
              align-items: center;

              .prefix {
                width: 20px;
                height: 60px;
                flex-shrink: 0;
              }

              .type {
                width: 60px;
                height: 60px;
                display: flex;
                align-items: center;
                flex-shrink: 0;

                svg {
                  font-size: 38px;
                }

                .icon-container {
                  position: relative;
                  .icon-shortcut-dir {
                    left: 0px !important;
                    bottom: 3px !important;
                  }
                  .icon-shortcut {
                    position: absolute;
                    left: 3px;
                    bottom: 0px;
                  }
                }

                .img-box {
                  width: 36px;
                  height: 36px;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  img {
                    overflow: hidden;
                    max-width: 36px;
                    max-height: 36px;
                  }
                }

                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
              }

              .name {
                display: flex;
                align-items: center;
                flex-grow: 1;
                height: 60px;
                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
                // width: calc(100% - 900px);
                min-width: 60px;

                a {
                  color: #5c70ff;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  text-decoration: none;

                  &:active {
                    color: #4959cc;
                  }
                }

                .template_icon_en {
                  width: 52px !important;
                }

                .template_icon {
                  overflow: unset;
                  width: 28px;
                  height: 16px;
                  margin: 0px 4px;
                }
              }

              .size {
                display: flex;
                align-items: center;
                width: 160px;
                height: 60px;
                flex-shrink: 0;

                span {
                  padding-left: 8px;
                  font-weight: 400;
                  font-size: 14px;
                  color: rgba(0, 0, 0, 0.5);
                }

                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
              }

              .action {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 160px;
                height: 60px;
                flex-shrink: 0;

                span {
                  padding-left: 8px;

                  button {
                    width: 64px;
                    height: 30px;
                    background: #ffffff;
                    border: 0.5px solid rgba(0, 0, 0, 0.3);
                    border-radius: 4px;
                    cursor: pointer;

                    &:hover {
                      background: #eaeaea;
                      border: 0.5px solid rgba(0, 0, 0, 0.4);
                    }

                    &:active {
                      background: #e2e2e2;
                      border: 0.5px solid rgba(0, 0, 0, 0.5);
                    }
                  }
                }

                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
              }
            }
          }
        }
      }
    }
  }
}

.h5-folder-view {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background: #fff;

  .list-body {
    flex-grow: 1;
    position: relative;

    .empty {
      height: 50%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .message {
        text-align: center;

        img {
          width: 120px;
        }

        span {
          font-size: 17px;
          color: rgba(0, 0, 0, 0.3);
        }
      }
    }

    .result {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      overflow: auto;
      flex-direction: column;

      .row {
        width: 100%;
        display: flex;
        align-items: center;

        .prefix {
          width: 20px;
          height: 60px;
          flex-shrink: 0;
        }

        .type {
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          flex-shrink: 0;

          svg {
            font-size: 46px;
          }

          .icon-container {
            position: relative;
            .icon-shortcut-dir {
              left: 0px !important;
              bottom: 3px !important;
            }
            .icon-shortcut {
              position: absolute;
              left: 3px;
              bottom: 0px;
            }
          }

          .img-box {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;

            img {
              overflow: hidden;
              max-width: 36px;
              max-height: 36px;
            }
          }
        }

        .name {
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 60px;
          box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
          overflow: hidden;

          .filename-container-noTemplate {
            margin-right: 20px;
          }

          .filename-container {
            display: flex;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .caption {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 400;
            font-size: 17px;
            color: #000000;
          }

          .template_icon_en {
            width: 52px !important;
          }
          .template_icon {
            flex-shrink: 0;
            overflow: unset;
            width: 28px;
            height: 16px;
            margin-left: 4px;
            margin-right: 20px;
          }

          .size {
            font-weight: 400;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);
            line-height: 18px;
          }
        }
      }
    }
  }
}
</style>
